import { jsx } from "react/jsx-runtime";
import { createSvgIcon } from "@mui/material/utils";
const FillIcon = createSvgIcon(/* @__PURE__ */ jsx("svg", { width: "32", height: "32", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx("g", { id: "prefix__icons/fill", children: /* @__PURE__ */ jsx("path", { id: "prefix__icon", d: "M16 3C8.8203 3 3 8.8203 3 16C3 23.1797 8.8203 29 16 29C23.1797 29 29 23.1797 29 16C29 8.8203 23.1797 3 16 3Z" }) }) }), "FillIcon");
export {
  FillIcon
};
